module.exports = require("wif");